module.exports = __webpack_public_path__ + "static/media/Why Choose 4.49cfbb4a.png";